import ExcelImportDialog from "./ExcelImportDialog";
import { PRIORITIES, TASK_STATUSES, REQ_STATUSES } from "./projectUtils";

export const REQ_CATEGORIES = ["Functional", "Non-Functional", "UI/UX", "Integration", "Security", "Performance", "Other"];

const TASK_CONFIG = {
  title: "Import Tasks from Excel", noun: "task", endpoint: "tasks", sheet: "Tasks", itemKey: "task",
  fileName: "AgencyOS-Task-Import-Template.xlsx",
  columns: [
    ["Task Name", "name", "Required. Short title of the task"],
    ["Description", "description", "Optional. Details for the developer"],
    ["Assigned To (Email)", "assigned_email", "Optional. Email of a team member (developer) in AgencyOS"],
    ["Priority", "priority", `Optional. ${PRIORITIES.join(" / ")} (default Medium)`],
    ["Status", "status", `Optional. ${TASK_STATUSES.join(" / ")} (default To Do)`],
    ["Start Date", "start_date", "Optional. YYYY-MM-DD, e.g. 2026-11-01"],
    ["Due Date", "due_date", "Optional. YYYY-MM-DD, not before Start Date"],
    ["Estimated Hours", "estimated_hours", "Optional. Number, e.g. 6"],
  ],
  samples: [
    ["Build login page", "Email + password login with validation", "developer@yourcompany.com", "High", "To Do", "2026-11-03", "2026-11-07", 12],
    ["Set up database", "", "", "Medium", "To Do", "2026-11-03", "2026-11-05", 6],
  ],
  previewCols: [["Task", "name"], ["Assigned To", "assigned_name"], ["Priority", "priority"], ["Status", "status"], ["Start", "start_date"], ["Due", "due_date"], ["Hours", "estimated_hours"]],
};

const REQ_CONFIG = {
  title: "Import Requirements from Excel", noun: "requirement", endpoint: "requirements", sheet: "Requirements", itemKey: "item",
  fileName: "AgencyOS-Requirement-Import-Template.xlsx",
  columns: [
    ["Title", "title", "Required. Short name of the requirement"],
    ["Description", "description", "Optional. What exactly is needed"],
    ["Category", "category", `Optional. ${REQ_CATEGORIES.join(" / ")} (default Functional)`],
    ["Priority", "priority", `Optional. ${PRIORITIES.join(" / ")} (default Medium)`],
    ["Status", "status", `Optional. ${REQ_STATUSES.join(" / ")} (default Draft)`],
    ["Assigned To (Email)", "assigned_email", "Optional. Email of a team member in AgencyOS"],
    ["Deadline", "deadline", "Optional. YYYY-MM-DD, e.g. 2026-11-30"],
  ],
  samples: [
    ["User login", "Customers sign in with email and password", "Functional", "High", "Draft", "pm@yourcompany.com", "2026-11-15"],
    ["Page load under 2s", "", "Performance", "Medium", "Draft", "", "2026-11-30"],
  ],
  previewCols: [["Requirement", "title"], ["Category", "category"], ["Priority", "priority"], ["Status", "status"], ["Assigned To", "assigned_name"], ["Deadline", "deadline"]],
};

export const TaskImportDialog = (props) => <ExcelImportDialog {...props} config={TASK_CONFIG} testid="task-import" />;
export const RequirementImportDialog = (props) => <ExcelImportDialog {...props} config={REQ_CONFIG} testid="req-import" />;
